import { defineStore } from 'pinia'
import { useAppStore } from './appStore'
import { api } from '../services/api'
import router from '../router'
import { useToast } from 'vuestic-ui'

export const useUserStore = defineStore('user', {
  state: () => ({
    user: localStorage.getItem('user@lifeadmin') ? JSON.parse(<string>localStorage.getItem('user@lifeadmin')) : {},
    token: localStorage.getItem('token@lifeadmin') ? localStorage.getItem('token@lifeadmin') : '',
  }),

  actions: {
    async signIn(formData: { email: string; password: string }) {
      const appStore = useAppStore()

      appStore.toggleLoading(true)
      try {
        const response = await api.post(`/auth/admin/sign-in`, {
          email: formData.email,
          password: formData.password,
        })

        this.user = response.data.user
        this.token = response.data.token

        localStorage.setItem('token@lifeadmin', response.data.token)
        localStorage.setItem('user@lifeadmin', JSON.stringify(response.data.user))

        await router.push({ name: 'dashboard' })
      } catch (e: any) {
        const { init } = useToast()
        if (e?.response?.data?.message) {
          init({ message: e.response.data.message, color: 'danger' })
        } else {
          init({ message: e.message, color: 'danger' })
        }
      } finally {
        appStore.toggleLoading(false)
      }
    },
    async logout() {
      localStorage.removeItem('token@lifeadmin')
      localStorage.removeItem('user@lifeadmin')
      this.user = {}
      this.token = ''

      await router.push({ name: 'login' })
    },
  },
})
